import { defineStore } from 'pinia'
import { useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useDeviceDownloadLogsStore = defineStore('deviceDownloadLogs', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getDeviceDownloadLogs: (state) => state.data?.data,
  },
  actions: {
    async indexDeviceDownloadLogs(params = {}) {
      try {
        const response = await axios.get('device-download-logs', {params} );
        this.data = response.data;
        return this.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showDeviceDownloadLog( deviceDownloadLogId, params = {}) {
      try {
        const response = await axios.get(`device-download-logs/${deviceDownloadLogId}`, {params} );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editDeviceDownloadLog( deviceDownloadLogId, params = {}) {
      try {
        const response = await axios.get(`device-download-logs/${deviceDownloadLogId}/edit`, {params} );
        return useEditForm(`device-download-logs/${deviceDownloadLogId}`, response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteDeviceDownloadLog( deviceDownloadLogId, params = {}) {
      try {
        const response = await axios.delete(`device-download-logs/${deviceDownloadLogId}`, {params} );
        toasteventbus.emit('add', {
          title: 'Device Download Log Deleted',
          text: `Device Download Log has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
